import { X } from "lucide-react";
import useEscapeKey from "../hooks/useEscapeKey";

interface ConfirmModalProps {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  danger?: boolean;
}

export default function ConfirmModal({ title, message, confirmLabel, cancelLabel, onConfirm, onCancel, danger }: ConfirmModalProps) {
  useEscapeKey(onCancel);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onCancel} />
      <div className="relative bg-white rounded-xl shadow-xl border border-grove-300 max-w-md w-full mx-4 p-6 animate-fade-in">
        <button onClick={onCancel} className="absolute top-3 right-3 text-bark-400 hover:text-bark-600">
          <X className="w-5 h-5" />
        </button>
        <h3 className="font-display text-lg font-semibold text-bark-800 mb-2">{title}</h3>
        <p className="text-sm text-bark-500 mb-6 leading-relaxed">{message}</p>
        <div className="flex items-center justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-bark-500 bg-white border border-grove-300 rounded-lg hover:bg-grove-50 transition-all"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 text-sm font-semibold text-white rounded-lg transition-all shadow-sm hover:shadow-md ${
              danger
                ? "bg-red-600 hover:bg-red-500"
                : "bg-honey-600 hover:bg-honey-500"
            }`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
